import { baseApi } from "../baseApi";

export type CallRoomRequest =
  | { kind: "instant"; target: string }
  | { kind: "scheduled"; target: string; start_at: number; duration_minutes: number };

export interface CallRoomResponse {
  room_id: string;
  not_before: number;
  expires_at: number;
}

export interface CallJoinTokenResponse {
  token: string;
  expires_in: number;
}

export const callApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createCallRoom: builder.mutation<CallRoomResponse, CallRoomRequest>({
      query: (body) => ({ url: "/calls", method: "POST", body }),
    }),
    getCallJoinToken: builder.mutation<CallJoinTokenResponse, { room_id: string }>({
      query: (body) => ({ url: "/calls/token", method: "POST", body }),
    }),
  }),
});

export const { useCreateCallRoomMutation, useGetCallJoinTokenMutation } = callApi;
